import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { ClientCredentialsTokenService } from './client-credentials-token.service';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientCredentialsService {
  // Shared in-flight/cached token Observable — reused by all concurrent callers
  private token$: Observable<any> | null = null;

  constructor(
    private http: HttpClient,
    private clientCredentialsTokenService: ClientCredentialsTokenService
  ) {}

  getToken(): Observable<any> {
    // Return cached token immediately if already fetched
    const cached = this.clientCredentialsTokenService.getToken();
    if (cached) {
      return of({ access_token: cached });
    }
    // Reuse the in-flight request if one is already pending
    if (!this.token$) {
      const url = `${environment.backend_server_url}/auth-client/oauth/token`;
      const body = new HttpParams().set('grant_type', 'client_credentials');
      this.token$ = this.http.post(url, body).pipe(
        map((accessToken: any) => {
          this.clientCredentialsTokenService.setToken(accessToken.access_token);
          return accessToken;
        }),
        catchError(() => {
          this.token$ = null; // Reset so next caller retries
          return throwError('CLIENT_CREDENTIALS_ERROR');
        }),
        shareReplay(1)
      );
    }
    return this.token$;
  }

  /** Call after logout to force a fresh token on next login */
  clearCache() {
    this.token$ = null;
    this.clientCredentialsTokenService.removeToken();
  }
}
